import { render, staticRenderFns } from "./bzwcbb.vue?vue&type=template&id=02538d3e&scoped=true&"
import script from "./bzwcbb.vue?vue&type=script&lang=js&"
export * from "./bzwcbb.vue?vue&type=script&lang=js&"
import style0 from "./bzwcbb.vue?vue&type=style&index=0&id=02538d3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02538d3e",
  null
  
)

export default component.exports